import { Modal } from 'almanac-ui/Modal'
import { Button } from 'components/Button'
import { useId } from '@react-aria/utils'
import { ConfirmModal } from 'hooks/useConfirmModal'

export const ConfirmDeleteModal = ({
  onPressOutside,
  onConfirm,
  onCancel,
  msg,
  confirmText = 'Delete',
}: ConfirmModal & { msg: string; confirmText?: string }) => {
  const id = useId()
  return (
    <Modal.Root onPressOutside={onPressOutside} size="xs" aria-labelledby={id}>
      <Modal.Header title={msg} id={id} />
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button onPress={onCancel} size="lg" variant="tertiary">
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button onPress={onConfirm} size="lg" variant="primary">
            {confirmText}
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}

export const buildDeleteModal = (msg: string) => (props: ConfirmModal) => <ConfirmDeleteModal msg={msg} {...props} />
